import { mergeAttributes, Node } from "@tiptap/core";

import { createNodeView } from "@/editor/utils/nodeView";

import type { NWVariable, NWVariableProps, NWVariableViewActions } from ".";

type Options = {};
type Storage = {
  variableValue: string | undefined;
};

export const NWVariableAdapter = Node.create<Options, Storage>({
  name: "nw-variable",
  group: "inline",
  draggable: false,
  selectable: false,
  content: "text*",

  priority: 200,

  inline: true,
  atom: true,

  addAttributes() {
    return {
      id: {
        default: null,
        parseHTML: element => element.getAttribute("id"),
      },
      name: {
        default: null,
        parseHTML: element => element.getAttribute("name"),
      },
      scope: {
        default: "project",
        parseHTML: element => element.getAttribute("scope"),
      },
      placeholder: {
        default: null,
        parseHTML: element => element.getAttribute("placeholder"),
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "nw-variable",
      },
    ];
  },

  addStorage() {
    return {
      variableValue: undefined,
    };
  },

  addNodeView() {
    return ({ node, editor, getPos }) => {
      return createNodeView<NWVariable, NWVariableProps, NWVariableViewActions>({
        tagName: this.type.name,
        editor,
        node,
        getPos,
        actions: {
          saveVariable: ({ params }) => {
            const [value] = params;
            this.storage.variableValue = value;
          },
        },
      });
    };
  },

  renderHTML({ HTMLAttributes }) {
    return ["nw-variable", mergeAttributes(HTMLAttributes)];
  },

  renderText({ node }) {
    return this.storage.variableValue ?? node.attrs.placeholder;
  },
});
